import { render, staticRenderFns } from "./LastDocumentsComponent.vue?vue&type=template&id=22712fe8&scoped=true&"
import script from "./LastDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./LastDocumentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./LastDocumentsComponent.vue?vue&type=style&index=0&id=22712fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22712fe8",
  null
  
)

export default component.exports